import { defineMessages } from "react-intl";

export default defineMessages({
    reviewUpdateMSB: {
        id: 'quoteandbind.ho.views.ho-your-home.Review/Update MSB',
        defaultMessage: 'Review/Update MSB',
    },
    refreshValuation: {
        id: 'quoteandbind.ho.views.ho-your-home.Refresh Valuation',
        defaultMessage: 'Refresh Valuation',
    },
    refreshValuationRequired: {
        id: 'quoteandbind.ho.views.ho-your-home.Refresh Valuation Required',
        defaultMessage: 'Refresh Valuation Required',
    },
    valuationUpdate: {
        id: 'quoteandbind.ho.views.ho-your-home.Valuation Updated',
        defaultMessage: 'Valuation Updated',
    },
    valuationSuccessfully: {
        id: 'quoteandbind.ho.views.ho-your-home.Valuation successfully updated',
        defaultMessage: 'Average Monthly Premium:',
    },
    valuationFailed: {
        id: 'quoteandbind.ho.views.ho-your-home.Valuation Failed Title',
        defaultMessage: 'Valuation Failed',
    },
    msbValuationFailedTitle:{
        id: 'twia.quoteandbind.ho.views.construction.MSB Valuation Failed',
        defaultMessage: 'MSB Valuation Failed'
    },
    msbValuationFailedMsg:{
        id: 'twia.quoteandbind.ho.views.construction.Valuation Failed Updated Message',
        defaultMessage: 'Address provided was not found by MSB. Please review and amend the location address or launch MSB to complete the valuation.'
    },
    msbAddressNotFoundMsg:{
        id: 'twia.quoteandbind.ho.views.construction.Valuation Failed Launch Message',
        defaultMessage: 'Address provided was not found by MSB.'
    },
    msbRefreshRequiredTitle:{
        id: 'twia.quoteandbind.ho.views.construction.Valuation Refresh Required Title',
        defaultMessage: 'Refresh Required'
    },
    msbRefreshRequiredMsg: {
        id: 'twia.quoteandbind.ho.views.construction.Valuation Refresh Required',
        defaultMessage: 'MSB was Reviewed/Updated, please Refresh Valuation in order to continue with the quote.'
    },
    unableToRetrieveValuation: {
        id: 'quoteandbind.ho.views.ho-your-home.Unable to retrieve valuation, please contact administrator',
        defaultMessage: 'Unable to retrieve valuation, please contact administrator.',
    }
})